import { isDevMode } from '@angular/core';
import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { Environment } from '../../environments/environment.model';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

// Factory function to create MSAL config from runtime configuration
export function createMsalConfig(config: Environment): Configuration {
    return {
        auth: {
            clientId: config.msal?.applicationClientId || '',
            authority: `https://${config.msal?.b2cTenantName}.b2clogin.com/${config.msal?.b2cTenantName}.onmicrosoft.com/${config.msal?.name}`,
            knownAuthorities: [`${config.msal?.b2cTenantName}.b2clogin.com`],
            redirectUri: config.msal?.redirectUri || '',
            postLogoutRedirectUri: config.msal?.redirectUri || '',
            navigateToLoginRequestUrl: true,
            clientCapabilities: ['CP1'],
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            storeAuthStateInCookie: isIE,
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                    if (containsPii) {
                        return;
                    }
                    if (isDevMode()) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error('MSAL Error:', message);
                            return;
                        case LogLevel.Info:
                            console.info('MSAL Info:', message);
                            return;
                        case LogLevel.Verbose:
                            console.debug('MSAL Debug:', message);
                            return;
                        case LogLevel.Warning:
                            console.warn('MSAL Warning:', message);
                            return;
                        default:
                            console.log('MSAL Log:', message);
                            return;
                    }
                },
                logLevel: isDevMode() ? LogLevel.Verbose : LogLevel.Error,
                piiLoggingEnabled: false,
            },
        },
    };
}

export function getProtectedResources(config: Environment) {
    return {
        api: {
            endpoint: `${config.api?.basePath}/api/v1`,
            scopes: [`https://${config.msal?.b2cTenantName}.onmicrosoft.com/${config.api?.applicationId}/CustomerNext.Api`],
        },
    };
}

export const graphMeEndpoint = {
    uri: 'https://graph.microsoft.com/v1.0/me',
    scopes: ['CustomerNext.Api'],
};
